export function onDomReady(callback) {
  window.addEventListener('turbo:load', callback);
}

export function onResizeWindow(callback) {
  window.addEventListener('resize', callback);
}
